import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import "./index.scss";
import googleplay from "../../assets/img/google-play.png";
import AppStore from "../../assets/img/app-store.png";
const MainNews = ({ google_play, news, app_store, nep }) => {
  return (
    <>
      <div className="MainNewsContainer">
        <div className="wrapper">
          <div className="NewsFlexBox">
            <div className="NewsBox">
              <h2 className="section-label">{nep ? " समाचार र सूचनाहरू" : "News & Notices"}</h2>
              <h1>
                {nep ? (
                  "हाम्रो समाचार र जानकारी"
                ) : (
                  <>
                    Our <span>news</span> & Information
                  </>
                )}
              </h1>
              <ul>
                {news.map((ne) => {
                  return (
                    <li>
                      <span>
                        {ne.day} <br /> {ne.month}
                      </span>
                      <Link
                        to={
                          ne.image == "" ? ne.file : `news-&-events/${ne.slug}`
                        }
                        target={ne.image == "" ? "_blank" : ""}
                      >
                        {ne.title}
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <Link to="/news-&-events" className="MoreBTN">
                {nep ? "थप हेर्नुहोस्" : "See More"}{" "}
                <ArrowRightAltIcon fontSize="small" />
              </Link>
            </div>
            <div className="AppDownloadBox">
              <div className="DownloadApp">
                <h1>
                  {nep ? (
                    "तत्काल डिजिटल भुक्तानी पाउनुहोस्"
                  ) : (
                    <>
                      Get Instant <span>Digital Payment</span> For Everyone
                    </>
                  )}
                </h1>
                <p>
                  {nep
                    ? "गुहेश्वरी स्मार्ट एप डाउनलोड गर्नुहोस् र आफ्नो बैंकिङलाई सरल बनाउनुहोस्।"
                    : "Download Guheswori Smart App and simplify your banking."}
                </p>
                <p>
                  {nep
                    ? "गुहेश्वरी स्मार्ट एप अब उपलब्ध छ। अहिले डाउनलोड गर्नुहोस्।"
                    : "Guheswori Smart App is now available."}
                </p>

                <Link to={google_play} target="_blank">
                  <img src={googleplay} alt="Download from Google Play" />
                </Link>
                <Link to={app_store} target="_blank">
                  <img src={AppStore} alt="Download from App Store" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MainNews;
